<template>
  <div :class="$style.base">
    <BaseInputLabel
      v-if="label"
      :text="label"
      :required="required"
      :info="info"
    />
    <div :class="$style.inputContainer">
      <BaseInput
        v-if="inputType === InputType.Perc"
        v-model="inputValue"
        type="number"
        unitLabel="percentage"
        :decimals="2"
        :maxValue="maxPercentage"
        :required="required"
        :minValue="minValue"
      />
      <BaseInput
        v-else
        v-model="inputValue"
        type="currency"
        :required="required"
        :minValue="minValue"
      />
      <div :class="$style.inputType">
        <BaseSwitch
          v-model="inputType"
          :options="[
            {
              value: InputType.Perc,
              label: '%'
            },
            {
              value: InputType.Fixed,
              label: '€'
            }
          ]"
          v-test="'_base-input-price-percentage-toggle'"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'BaseInputPricePercentage',
  inheritAttrs: false,
};

export enum InputType {
  Fixed = 'FIXED_AMOUNT',
  Perc = 'PERCENTAGE',
}
</script>

<script
  setup
  lang="ts"
>
const props = defineProps<{
  info?: string;
  label?: string;
  minValue?: number;
  modelValue: number;
  required?: boolean;
  type: InputType;
  maxPercentage?: number;
}>();

const emit = defineEmits(['update:modelValue', 'update:type']);

const inputType = computed({
  get() {
    return props.type;
  },
  set(value) {
    emit('update:type', value);
  },
});

const inputValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

watch(inputType, (newValue) => {
  if (newValue === InputType.Fixed) {
    inputValue.value = props.modelValue * 100;
  } else {
    inputValue.value = props.maxPercentage
      ? Math.min(props.modelValue / 100, props.maxPercentage)
      : props.modelValue / 100;
  }
});
</script>

<style
  lang="scss"
  module
>
.inputContainer {
  display: flex;
}

.inputType {
  position: relative;
  z-index: 1;
  margin-left: -11px;
}
</style>
